module.exports = __webpack_public_path__ + "img/user-icon.17b4cea8.svg";